import React from "react";
import MapImpact from "./mapImpact";
import OurImpact from "./ourImpact";
import TestimonialVideo from "../budha-fellowship-program/testimonial/testimonialVideo";
import TestimonialContent from "../budha-fellowship-program/testimonial/testimonialContent";
import Catalyse from "./catalysing";
import Banner from "./banner";

export default function Index() {
  return (
    <div className="mt-8">
      <Banner />
      
      <MapImpact
        section="02"
        title="Mapping the collective impact by our Buddha Fellows"
      />
      <Catalyse />
      <OurImpact />
      <TestimonialVideo
        section="05"
        title="Voices of resilience, testimonies of growth."
      />
      <TestimonialContent section="06" title="" />
    </div>
  );
}
